<template>
    <div class="eos__list table-wrp">
        <el-table :data="eosList" border class="eos__list--table">
            <el-table-column type="expand">
                <template slot-scope="props">
                   <el-table :data="props.row.shifts" width="100%" class="eos__list--shifts">
                    <el-table-column width="10%" prop="sequence" label="Sequence">
                        <template slot-scope="scope">
                            <div class="value">{{ scope.row.sequence }}</div>
                        </template>
                        <template width="20%" slot-scope="scope">
                            <div class="value">{{ scope.row.sequence }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="20%" prop="name" label="Name">
                        <template slot-scope="scope">
                            <div class="value">{{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="20%" prop="startTime" label="Start Time">
                        <template slot-scope="scope">
                            <div class="value">{{ scope.row.startTime }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="50%" prop="services" label="Services">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.services" class="eos__list--services">
                                <el-table-column prop="name" label="Name">
                                    <template slot-scope="scope">
                                        <div class="value">{{ scope.row.name }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="startTime" label="Start Time">
                                    <template slot-scope="scope">
                                        <div class="value">{{ scope.row.startTime }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="daysOfWeek" label="Days of Week">
                                    <template slot-scope="scope">
                                        <div class="days-of-week">
                                            <el-tag v-for="day in scope.row.daysOfWeek" :key="day" effect="dark" size="small">{{ day }}</el-tag>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                   </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="from" label="Start Date"></el-table-column>
            <el-table-column label="Actions" align="center" width="280">
                <template slot-scope="scope">
                    <div class="btns clear eos__list--actions">
                        <button class="eos__list--edit" @click="$emit('edit', scope.row)">Copy</button>
                        <button class="eos__list--delete" @click="$emit('delete', scope.row)">Delete</button>
                    </div>
                </template>
            </el-table-column>
            <template slot="empty">
                <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                <div v-else>No Data</div>
            </template>
        </el-table>
    </div>
</template>
<script>
export default {
    props: {
        eosList: Array,
        loading: Boolean
    }
}
</script> 


// WEBPACK FOOTER //
// src/components/eos/components/EosList.vue